<template>
	<section class="slide grey fullscreen" id="introduction">
		<div class="masthead">

			<h1>Chordictionary 🎸</h1>
			<h2>
				Lightning-fast chord recognition and graphic representation for any string/fretted instrument.<br />
			</h2>
		</div>
		<div class="arrow-down"></div>
	</section>
</template>

<script>
	export default {
		name: 'masthead'
	}
</script>